import { Loading, useLoading, useMoment } from '@gorila-shared-ui/components';
import { useParams } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { getAssetState } from '../../services/trackingService';
import { apiParamsState } from '../../storage/app';
import { assetState } from '../../storage/assets';
import { assetStartTimeState, assetStates } from '../../storage/tracking';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { TrackingInfo } from '../tracking/TrackingInfo';
import { TrackingTable } from '../tracking/TrackingTable';

export function TrackingPage() {
  const { theme } = useStyles();
  const apiParams = useRecoilValue(apiParamsState);
  const { assetId } = useParams();
  const asset = useRecoilValue(assetState(assetId ?? ''));
  const setAssetStates = useSetRecoilState(assetStates(assetId ?? ''));
  const setAssetStartTime = useSetRecoilState(assetStartTimeState(assetId ?? ''));
  const { timeMinusHours } = useMoment();
  const { loading, startLoading, stopLoading } = useLoading();
  const { showFailFeedback } = useFeedback();

  useUpdateEffect(() => {
    const loadHistoricStates = async () => {
      if (!apiParams?.clientId || !assetId || !asset?.subClient?._id) return;
      startLoading();
      const now = Date.now();
      setAssetStartTime(now);
      const { assetState: historicStates, error } = await getAssetState(
        apiParams.clientId,
        assetId,
        timeMinusHours(now, 1),
        undefined,
        asset.subClient._id,
      );
      if (!error && historicStates) {
        setAssetStates(historicStates);
      } else {
        showFailFeedback(error ?? 'Ocurrió un error al cargar el histórico.');
        setAssetStates(undefined);
      }
      stopLoading();
    };

    loadHistoricStates();
  }, [apiParams?.clientId, assetId, asset?.subClient?._id]);

  return (
    <FloatingCardsLayout
      contentSize={660}
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          {loading && <Loading />}
          {!loading && asset && (
            <>
              <TrackingInfo />
              <TrackingTable />
            </>
          )}
        </FloatingCardContent>
      }
    />
  );
}
